/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Essential_Cookies_DescriptionInputs */

const en_essential_cookies_description = /** @type {(inputs: Essential_Cookies_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in, security, and your language choice. Always on.`)
};

const es_essential_cookies_description = /** @type {(inputs: Essential_Cookies_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio de sesión, seguridad y tu idioma. Siempre activas.`)
};

const fr_essential_cookies_description = /** @type {(inputs: Essential_Cookies_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion, sécurité et votre langue. Toujours actifs.`)
};

/**
* | output |
* | --- |
* | "Sign-in, security, and your language choice. Always on." |
*
* @param {Essential_Cookies_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const essential_cookies_description = /** @type {((inputs?: Essential_Cookies_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Essential_Cookies_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_essential_cookies_description(inputs)
	if (locale === "es") return es_essential_cookies_description(inputs)
	return fr_essential_cookies_description(inputs)
});